import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { r as renderIconSVG } from './utils/renderIconSVG-fObqPj4k.js';
import { R as RemoteIcon } from './RemoteIcon/RemoteIcon-CXxKteYq.js';
import { i as isHorizontalFlipOnRTL } from './utils/isHorizontalFlipOnRTL-7yAAaYS8.js';
import { g as getIconSize } from './utils/getIconSize-CQug84dd.js';
import { I as IconClassWrapper, a as IconWrapperStyled } from './Icon.styles-0tU6Ri5A.js';
import { u as useIsMobile } from '../theme/MobileThemeProvider/useIsMobile-B-VP6bHU.js';

const InternalIcon = ({
  isMobile,
  type,
  size,
  transform,
  isClickTarget = false,
  'data-testid': dataTestId,
  ...rest
}) => {
  const iconFontSize = getIconSize(size, isMobile);
  if (typeof type === 'string') {
    return /*#__PURE__*/React__default.createElement(RemoteIcon, _extends({}, rest, {
      key: type,
      type: type,
      size: size,
      fontSize: iconFontSize,
      transform: transform,
      isClickTarget: isClickTarget,
      "data-testid": dataTestId
    }));
  }
  const [iconName, horizontalFlipOnRTL] = isHorizontalFlipOnRTL(type.iconName);
  const icon = {
    ...type,
    iconName
  };
  return /*#__PURE__*/React__default.createElement(IconClassWrapper, {
    $spin: iconName === 'spinner',
    $size: size,
    $fontSize: iconFontSize
  }, className => /*#__PURE__*/React__default.createElement(IconWrapperStyled, _extends({}, rest, {
    $isClickTarget: isClickTarget,
    $fontSize: iconFontSize,
    $horizontalFlipOnRTL: horizontalFlipOnRTL,
    dangerouslySetInnerHTML: {
      __html: renderIconSVG(icon, transform, className)
    }
    // Used to help identify which icon is being used for testing purposes
    ,
    "data-testid": dataTestId || `storm-ui-icon-${iconName}`
  })));
};
const Icon = props => {
  const isMobile = useIsMobile();
  return /*#__PURE__*/React__default.createElement(InternalIcon, _extends({
    isMobile: isMobile
  }, props));
};

export { Icon as I, InternalIcon as a };
//# sourceMappingURL=Icon-BVCquTfq.js.map
